import React from "react";

function Footer() {
  return (
    <footer id="footer">
      <div className="footer-con">
        <div className="touch-con">
          <div className="touch-box">
            <h3>Get in touch</h3>
            <p>Contact@abrahamkolade.com</p>
            <h5>Lagos, NG</h5>
          </div>
          <div className="bullet">
            <h5>Made with ♥ & ♫ | Kolade Abraham</h5>
          </div>
        </div>
        <div className="touch-con second">
          <h3>Let's Connect</h3>
          <div className="social-links">
            <a
              href="https://www.linkedin.com/in/kolade-m-abraham/"
              target="_blank"
              rel="noreferrer noopener"
            >
              Linkedin
            </a>
            <a
              href="https://dribbble.com/kola_abr"
              target="_blank"
              rel="noreferrer noopener"
            >
              Dribble
            </a>
            <a
              href="https://twitter.com/Kola_Abr"
              target="_blank"
              rel="noreferrer noopener"
            >
              Twitter
            </a>
            <a
              href="https://www.behance.net/kola_abr"
              target="_blank"
              rel="noreferrer noopener"
            >
              Behance
            </a>
          </div>
          <h5 className="add">Made with ♥ & ♫ | Kolade Abraham</h5>
          <h5>Copyrights © 2023</h5>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
